// 共通のInViewアニメーションテンプレート
// このクラスをベースに、異なるアニメーション効果を追加して使ってください
import {deepMerge} from "js/utils/Utils";
import { gsap } from 'gsap'

import Common from 'js/_core/Common'
import InViewItem from 'js/modules/_base/effects/helper/InViewItem'

const defaults = {
    instanceName: 'fadeInInViewItem',
    $names: {
        trigger: '[data-animation="fade-in-view"]',
    },
    isRepeat: false
}

export default class FadeInViewItem {
    /**
     * IntersectionObserverManager の外部注入用プロパティ
     * - デフォルトでは Common.iom を使用
     * - 複数のクラスで同じ iom を使い回す場合などに外部から設定可能
     */
    _iom = null

    constructor(options = {}) {
        this.$contentRoot = document
        this.$triggerAll = []
        this.inViewItems = []

        deepMerge(this, defaults, options)
    }

    // 初期化
    init() {
        this._setElements()

        this.$triggerAll.forEach(($trigger, i) => {
            const isRepeatAttr = $trigger.dataset.animationRepeat
            const isRepeat = isRepeatAttr !== undefined ? isRepeatAttr === 'true' : this.isRepeat

            const inViewItem = new InViewItem({
                $contentRoot: this.$contentRoot,
                $trigger,
                index: i,
                iom: this._iom ? this._iom : Common.iom,  // 外部から渡された iom があればそれを使用、なければ共通の Common.iom を使用
                isIomRemoved: !isRepeat, // 繰り返しアニメーションを行う場合は iom を削除しない

                // 初期スタイルの設定
                setInitializedStyle: ($el) => {
                    this.setInitialStyle($el, i)
                },

                // ビューポート内に入った時のアニメーション
                inViewAnimation: async ($el) => {
                    await this.animateIn($el, i)
                },

                // ビューポート外に出た時のアニメーション（必要に応じて拡張）
                outOfViewAnimation: async ($el) => {
                    await this.animateOut($el, i)
                },
            })

            this.inViewItems.push(inViewItem)
            inViewItem.init()
        })
    }

    // 破棄処理
    destroy() {
        this.inViewItems.forEach((item) => item.destroy())
    }

    // 再実行処理（必要に応じて）
    run() {
        this.inViewItems.forEach((item) => item.run())
    }

    // 要素取得
    _setElements() {
        this.$triggerAll = this.$contentRoot.querySelectorAll(this.$names.trigger)
    }

    // 初期状態のスタイル設定（非表示）
    setInitialStyle($el, index) {
        gsap.set($el, {
            opacity: 0,
        })
    }

    // 表示アニメーション（フェードイン）
    async animateIn($el, index) {
        requestAnimationFrame(() => {
            gsap.to($el, {
                opacity: 1,
                duration: 0.8,
                ease: 'power2.out',
            })
        })
    }

    // 非表示アニメーション（必要に応じて拡張）
    async animateOut($el, index) {
        // 例: gsap.to($el, { opacity: 0 });
    }
}